import path from '../util/path';

$('#date-filter select.input-control').on('change', function(event) {
  event.preventDefault()
  const value = $(this).val();
  const name = $(this).attr('name');

  document.location.href = path(window.location.href, name, value);
});



// WEBPACK FOOTER //
// ./scripts/pages/project.js